import i18next from 'i18next'
import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const LoadLocales = () => {
    return axios.get('/api/services/app/TextService/GetFrontendTexts', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    }).then(result => (
        new Promise((resolve, reject) => {
            let translationObj = {}
            let values = {}
            if(result.data  && result.data.result)
            {
                result.data.result.forEach(itm=> {
                    values[itm.key] = itm.value
                })
            }
            translationObj["translation"] = values
            
            i18next.init({
                lng: 'pl',
                debug: true,
                resources: { ['pl']: translationObj },
            }, (err) => {
                if (err) {
                    reject(err)
                    return
                }

                resolve()
            })
        })
    ))
    .catch(err => Promise.reject(err))

}
export const t = (key, opt) => i18next.t(key,opt)
export const currentLocale = () => i18next.language